import api from "../Api";

export const adminLoginApi = (data) =>
  api.post("/admin/auth/login", data);

export const adminLogoutApi = () =>
  api.post("/admin/auth/logout");

export const getAdminDashboardCardsApi = () => {
  return api.get("/admin-service/dashboard/cards");
};

export const getAffiliateuserlist = (page = 1, search = '') => {
  return api.get(`/admin-service/users/activities?page=${page}&page_size=10&search=${search}`);
};

export const getuserlist = (page, search, status, fromDate = '', toDate = '', pageSize = 10) => {
  let url = `/admin-service/users/list?page=${page}&page_size=${pageSize}&search=${search}&status=${status}`;

  if (fromDate) {
    url += `&from_date=${fromDate}`;
  }

  if (toDate) {
    url += `&to_date=${toDate}`;
  }

  return api.get(url);
};

export const getAffiliatelist = (page, search, status = '', affiliateType = '', fromDate = '', toDate = '', pageSize = 10) => {
  let url = `/admin-service/affiliates/list?page=${page}&page_size=${pageSize}&search=${search}&status=${status}&affiliate_type=${affiliateType}&from_date=${fromDate}&to_date=${toDate}`;
  // from_date=2026-01-01&to_date=2026-01-31
  // if (fromDate) {
  //   url += `&from_date=${fromDate}`;
  // }
  // if (toDate) {
  //   url += `&to_date=${toDate}`;
  // }
  return api.get(url);
};

export const getPropertyDropdown = (Accountid) => {
  return api.get(`/property-service/properties/list?account_id=${Accountid}`);
};

export const getAffiliateView = (AffiliteId) => {
  return api.get(`/admin-service/affiliates/${AffiliteId}/details`);
};

export const getAffiliateReferralrequest = (page, search, status) => {
  return api.get(`/admin-service/referrals/requests?page=${page}&page_size=10&is_admin_approve=${status}&search=${search}`);
};

export const getUerReferralrequest = (page, search, status) => {
  return api.get(`/admin-service/users/referrals/requests?page=${page}&page_size=10&is_admin_approve=${status}&search=${search}`);
};

export const assignReferralRegisterApi = (data) => {
  return api.post('/admin-service/referrals/assign-register', data);
};

export const getwithdrawrequests = (page, search, status) => {
  return api.get(`/admin-service/withdraws/list?page=${page}&page_size=10&search=${search}&status=${status}`);
};


export const getProtestAndExamptions = (page, type, status, search = '') => {
  return api.get(
    `/admin-service/protests-exemptions/list?page=${page}&page_size=10&type=${type}&protest_status=${status}&search=${search}`
  );
};

export const getAnalyticsDataApi = () => {
  return api.get(`/admin-service/analytics/trends`);
};

export const getAnalyticsGraphDataApi = (period) => {
  return api.get(`/admin-service/analytics/graph?period=${period}`);
};

// /admin-service/analytics/graph?period=year

// /admin-service/protests-exemptions/update-status
export const updateProtestAndExemptionStatus = (data) => {
  return api.put(`/admin-service/protests-exemptions/update-status`, data);
};

export const updateAssessedValues = (data) => {
  return api.put(`/admin-service/protests-exemptions/update-assessed-values`, data);
};

export const updateContingencySplits = (data) => {
  return api.put(`/admin-service/protests-exemptions/update-contingency-splits`, data);
};

export const generatePropRefundInvoice = (data) => {
  return api.post(`/admin-service/prop-refund-invoices/generate`, data);
};

export const sendMarketValueEmail = (data) => {
  return api.post(`/admin-service/prop-refund-invoices/send-market-value-email`, data);
};

export const sendSettlementEmail = (data) => {
  return api.post(`/admin-service/prop-refund-invoices/send-settlement-email`, data);
};

export const getPropRefundInvoicesList = (page = 1, pageSize = 10, paymentStatus = '', search = '') => {
  return api.get(
    `/admin-service/prop-refund-invoices/list?page=${page}&page_size=${pageSize}&payment_status=${paymentStatus}&search=${search}`
  );
};

export const exportPropRefundInvoices = (paymentStatus = '', search = '') => {
  const url = `/admin-service/prop-refund-invoices/export?payment_status=${encodeURIComponent(paymentStatus)}&search=${encodeURIComponent(search)}`;
  return api.get(url, {
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

export const Admintotalreferrallist = (page = 1, pageSize = 10, status = '', search = '', earning_type = '', start_date = '', end_date = '') => {
  return api.get(`/admin-service/userAffiliateReferalsList?page=${page}&page_size=${pageSize}&status=${status}&search=${search}&earning_type=${earning_type}&start_date=${start_date}&end_date=${end_date}`);
};

export const exportReferrals = (status = '', search = '') => {
  const url = `/admin-service/userAffiliateReferalsList/export?status=${encodeURIComponent(status)}&search=${encodeURIComponent(search)}`;
  return api.get(url, {
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

// propertyid

export const Propertydocuments = (propertyid) => {
  return api.get(`/property-service/properties/${propertyid}/documents`);
};

// /property-service/properties/7d7336de-e4cd-420d-8a7f-bfdb2414bf11/documents


export const AdminApproveReferralLinks = (data) => {
  return api.post(`/admin-service/referral-links/approve`, data);
};

export const AdminupdateAffiliatetype = (data) => {
  return api.post(`/admin-service/affiliates/update-commission`, data);
};

// stripe code 

// /affiliate-service/affiliate/payment-dashboard

// /admin-service/payout-requests/list?page=1&page_size=10&status=&search=
export const getAdminpayoutlist = (page, pageSize, status, search) => {
  return api.get(`/admin-service/payout-requests/list?page=${page}&page_size=${pageSize}&status=${status}&search=${search}`);
}

export const paymentdashboard = () => {
  return api.get(`/affiliate-service/affiliate/payment-dashboard`);
}
export const getpayoutrequests = () => {
  return api.get(`/affiliate-service/affiliate/payout-requests`);
}


export const getcheckbalance = (userid) => {
  return api.get(`/payment-service/withdrawal/balance?user_id=${userid}`);
};

export const fetchwithdraRequest = (userid, amount) => {
  return api.post(`/payment-service/withdrawal/request?user_id=${userid}&amount=${amount}`);
};

export const fetchwithdraonboardinglink = (userid, returnlink, refreshlink) => {
  return api.get(`/payment-service/withdrawal/onboarding-link?user_id=${userid}&return_url=${returnlink}&refresh_url=${refreshlink}`);
};

// Retry withdraw

// /payment-service/withdrawal/request?user_id=55&amount=10
export const fetchwithdraRetry = (userid, amount) => {
  return api.post(`/payment-service/withdrawal/request?user_id=${userid}&amount=${amount}`);
};

export const fetchkycstatus = (userid) => {
  return api.get(`/payment-service/withdrawal/kyc-status/${userid}`);
};

export const fetchstripewebhooks = (data, headers = {}) => {
  const config = {
    headers: {
      ...headers,
    }
  };
  return api.post(`/payment-service/webhooks/stripe`, data, config);
};

export const fetchNDASign = (data) => {
  return api.post(`/affiliate-service/nda/sign`, data);
};

// /affiliate-service/nda/sign

export const exportAffiliates = (search = '', status = '', affiliateType = '', fromDate = '', toDate = '') => {
  let url = `/admin-service/affiliates/export?search=${search}&status=${status}&affiliate_type=${affiliateType}`;
  if (fromDate) {
    url += `&from_date=${fromDate}`;
  }
  if (toDate) {
    url += `&to_date=${toDate}`;
  }
  return api.get(url, {
    responseType: 'blob'
  });
};

export const exportusers = (search = '', status = '', affiliateType = '', fromDate = '', toDate = '') => {
  let url = `/admin-service/users/export?search=${search}&status=${status}&affiliate_type=${affiliateType}`;
  if (fromDate) {
    url += `&from_date=${fromDate}`;
  }
  if (toDate) {
    url += `&to_date=${toDate}`;
  }
  return api.get(url, {
    responseType: 'blob'
  });
};

// Version List

// /admin-service/admin/app-versions

export const fetchVersionlist = () => {
  return api.get(`/admin-service/admin/app-versions`);
};

// Update Android Version
export const updateAndroidVersion = (data) => {
  return api.put(`/admin-service/admin/app-versions/android`, data);
};

// Update iOS Version
export const updateIosVersion = (data) => {
  return api.put(`/admin-service/admin/app-versions/ios`, data);
};

// Chat Messages

// /api/chat-service/conversation
export const getChatusers = () => {
  return api.get(`/chat-service/conversations`);
};

// /chat-service/conversations/1
export const getChatMessages = (conversationId) => {
  return api.get(`/chat-service/conversations/${conversationId}/messages?page=1&page_size=200`);
};
// /chat-service/messages
export const sendChatMessage = (formData) => {
  return api.post(`/chat-service/messages`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Notifications
export const getNotifications = (page = 1, pageSize = 20, type = 'notification') => {
  return api.get(`/notification-service/notifications?page=${page}&page_size=${pageSize}&type=${type}`);
};

export const markNotificationAsSeen = (notificationId) => {
  return api.post(`/notification-service/notifications/${notificationId}/seen`);
};

export const markAllNotificationsAsSeen = () => {
  return api.post(`/notification-service/notifications/seen-all`);
};

// Admin notifications
// filters: { search, status, audience_type, from_date, to_date }
export const getAdminNotificationsApi = (page = 1, pageSize = 20, filters = {}) => {
  const params = {
    page,
    page_size: pageSize,
  };
  if (filters.search) {
    params.search = filters.search;
  }
  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.audience_type) {
    params.audience_type = filters.audience_type;
  }
  if (filters.from_date) {
    params.from_date = filters.from_date;
  }
  if (filters.to_date) {
    params.to_date = filters.to_date;
  }
  return api.get('/notification-service/api/admin/notifications', { params });
};

export const sendAdminNotificationApi = (data) => {
  return api.post(`/notification-service/api/admin/notifications/send`, data);
};

export const uploadAdminNotificationImageApi = (formData) => {
  return api.post(`/notification-service/api/admin/notifications/upload-image/s3`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getAdminNotificationStatsApi = (notificationId) => {
  return api.get(`/notification-service/api/admin/notifications/${notificationId}/stats`);
};


// Admin user management
export const forcePasswordUpdate = (userId, forcePasswordUpdateFlag = true) => {
  return api.post(`/admin-service/users/force-password-update`, {
    user_id: userId,
    force_password_update: forcePasswordUpdateFlag,
  });
};

// /admin-service/users/force-mobile-update
export const forceMobileUpdate = (userId, forceMobileUpdateFlag = true) => {
  return api.post(`/admin-service/users/force-mobile-update`, {
    user_id: userId,
    force_mobile_update: forceMobileUpdateFlag,
  });
};

// training library api
export const getTrainingLibraryList = ({
  page = 1,
  limit = 20,
  search = "",
  audience_filter = "",
  content_type_filter = "",
  status = "",
} = {}) => {
  // Build URL with server-side filters instead of filtering on the frontend
  let url = `/training-library-service/training-library?page=${page}&limit=${limit}&search=${search}&audience_filter=${audience_filter}&content_type_filter=${content_type_filter}&status_filter=${status}`;

  if (status) {
    url += `&status=${status}`;
  }

  return api.get(url);
};

export const addTrainingLibrary = (data) => {
  return api.post(`/training-library-service/training-library`, data);
};

// Update existing training library item
export const updateTrainingLibrary = (id, data) => {
  return api.put(`/training-library-service/training-library/${id}`, data);
};

// Upload training library assets (video/pdf file and/or thumbnail image)
// Expects FormData with keys like: file, thumbnail
export const uploadTrainingLibraryFiles = (formData) => {
  return api.post(`/training-library-service/training-library/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update training library status (active/inactive) using PATCH
export const updateTrainingLibraryStatus = (id, isActive, userId) => {
  return api.patch(`/training-library-service/training-library/${id}/activate?is_active=${isActive}&updated_by=${userId}`);
};

// Fetch user roles by email (pre-login)
export const getRolesByEmail = (email) => {
  return api.get(`/user-service/roles-by-email`, {
    params: { email },
    headers: {
      "X-API-Key": "andy-internal-api-key-2024-change-in-production",
    },
  });
};

// SMS service - send welcome message
export const sendWelcomeSms = (data) => {
  return api.post(
    `/sms-service/sms/send`,
    data,
    {
      headers: {
        "X-API-Key": "andy-internal-api-key-2024-change-in-production",
        "Content-Type": "application/json",
      },
    }
  );
};

// Update user active / inactive status
// POST /admin-service/users/status
export const updateUserStatus = (data) => {
  return api.post(`/admin-service/users/status`, data);
};

// Add wallet credit/debit for a user (multipart payload with optional evidence file)
export const addUserWalletApi = (formData) => {
  return api.post(`/admin-service/users/wallet/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadSupportingDocumentsApi = (formData) => {
  return api.post(`/property-service/supporting-documents`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update an address by ID
export const updateAddress = (addressId, data) => {
  return api.put(`/admin-service/addresses/${addressId}`, data);
};
export const uploadSettlementWaiverDocumentApi = (formData) => {
  return api.post('/admin-service/property-settlement-waiver-document/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// Coupons apis

export const getCouponslistApi = (page = 1, pageSize = 20, search = '', scope = '', status = '') => {
  const q = encodeURIComponent(search ?? '');
  const s = encodeURIComponent(scope ?? '');
  const st = encodeURIComponent(status === 'all' ? '' : (status ?? ''));
  let url = `/coupon-service/coupons?page=${page}&page_size=${pageSize}&search=${q}`;
  if (s) {
    url += `&scope=${s}`;
  }
  if (st) {
    url += `&status=${st}`;
  }
  return api.get(url);
};

export const getCouponRedemptionsApi = (page = 1, pageSize = 10, search = '', status = '') => {
  const q = encodeURIComponent(search ?? '');
  const s = encodeURIComponent(status ?? '');
  return api.get(`/admin-service/coupons/redemptions?page=${page}&page_size=${pageSize}&search=${q}&status=${s}`);
};

export const createCoupon = (data) => {
  return api.post(`/coupon-service/coupons`, data);
};

export const updateCoupon = (id, data) => {
  return api.patch(`/coupon-service/coupons/${id}`, data);
};

// campaign api
export const getCampaignLeadsourceList = (search = '', fromDate = '', toDate = '', page = 1, limit = 20, status = null) => {
  return api.get(`/admin-service/campaignLeadsourceList?page=${page}&limit=${limit}&search=${search}&from_date=${fromDate}&to_date=${toDate}&status=${status}`);
};

export const getCampaignLeadStepList = (search = '', fromDate = '', toDate = '', page = 1, limit = 20, status = null) => {
  return api.get(`/admin-service/campaignLeadStepList?page=${page}&limit=${limit}&search=${search}&from_date=${fromDate}&to_date=${toDate}`);
};

export const getCampaignLeadEstimateList = (search = '', fromDate = '', toDate = '', page = 1, limit = 10) => {
  const q = encodeURIComponent(search ?? '');
  return api.get(
    `/admin-service/campaignLeadEstimateList?page=${page}&limit=${limit}&search=${q}&from_date=${fromDate}&to_date=${toDate}`
  );
};

export const sendCampaignLeadEstimate = (data) => {
  return api.post('/campaign-lead-service/send-estimate', data);
};

// Property provisioning API
export const provisionPropertyApi = (data) => {
  return api.post('/admin-service/campaign-property-admin/provision', data);
};

// Upload property documents to S3
export const uploadPropertyDocumentApi = (formData) => {
  return api.post('/campaign-lead-service/supporting-documents/upload/s3', formData, {
    headers: {
      // Let axios set multipart boundary; a bare multipart type breaks file parsing
      'Content-Type': null,
    },
  });
};

// Bulk property provisioning – Excel template download
export const downloadPropertyBulkTemplateApi = () => {
  return api.get('/admin-service/campaign-property-admin/provision/bulk/excel/template', {
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  });
};

// Bulk property provisioning – upload Excel file directly
export const bulkProvisionPropertiesExcelApi = (formData) => {
  return api.post('/admin-service/campaign-property-admin/provision/bulk/excel', formData, {
    headers: {
      'Content-Type': null,
    },
  });
};

export const getAvailableReferralCodesApi = () => {
  return api.get('/user-service/api/users/available-referral-codes');
};

export const bulkUploadReferralCodesApi = (formData) => {
  return api.post('/admin-service/upload/appflyer/refralsLink', formData, {
    headers: {
      'Content-Type': null,
    },
  });
};

export const createMeetingApi = (data) => {
  return api.post('/meet-service/api/v1/meetings', data);
};

// https://api-andyv2.andyreach.com/api/meet-service/api/v1/meetings

export const getMeetingListApi = (page = 1, pageSize = 20, search = '', status = '', dateFilter = '') => {
  let url = `/meet-service/api/v1/meetings?page=${page}&page_size=${pageSize}&sort_by=scheduled_at&sort_order=desc`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (status && status !== 'All') {
    url += `&status=${encodeURIComponent(status)}`;
  }
  // Optional dateFilter logic if API supports it, like from_date & to_date
  return api.get(url);
};

export const getCalendlyEventTypesApi = () => {
  return api.get('/meet-service/api/v1/calendly/event-types?scope=user&active_only=true&count=100');
};

export const getCalendlyAvailableTimesApi = (params) => {
  return api.get('/meet-service/api/v1/calendly/available-times', { params });
};

export const updateMeetingApi = (id, data) => {
  return api.patch(`/meet-service/api/v1/meetings/${id}`, data);
};

export const cancelMeetingApi = (id) => {
  return api.post(`/meet-service/api/v1/meetings/${id}/cancel`);
};

export const deleteMeetingApi = (id) => {
  return api.delete(`/meet-service/api/v1/meetings/${id}`);
};

export const fetchPropertyReportLandingApi = (page = 1, pageSize = 10, search = '') => {
  return api.get(`/property-service/admin/property-report-landing-page?page=${page}&page_size=${pageSize}&search=${search}`);
};

// =================== Sales Dashboard Endpoints ===================

export const getSalesClientEnrollmentsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/client-enrollments', { params });
};

export const getSalesRecruiterEnrollmentsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/recruiter-enrollments', { params });
};

export const getSalesAppDownloadsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/app-downloads', { params });
};

export const getSalesRecruiterClientRegistrationsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/recruiter-client-registrations', { params });
};

export const getSalesAnalyticsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/analytics', { params });
};

export const getSalesFilingsApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/filings', { params });
};

export const getSalesTopRecruitersApi = (params = {}) => {
  return api.get('/admin-service/sales-dashboard/top-recruiters', { params });
};
